import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';
import { NavLink } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSettings } from 'hooks/useSettings';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';
import { storageKeys } from 'config/settings.json';

import './_buttonSet.scss';

const resetScrollPosition = () => window.scrollTo(0, 0);
const SMART_ASSIST_HOME_BUTTONS = {
  training: {
    text: 'nav.train',
    label: 'Training',
    icon: 'fas fa-graduation-cap',
    target: '/main/training',
  },
  promote: {
    text: 'nav.promote',
    label: 'Marketing',
    icon: 'fas fa-megaphone',
    target: '/main/promote',
  },
  sell: {
    text: 'nav.sell',
    label: 'Selling',
    icon: 'fas fa-chart-line-up',
    target: '/main/sell',
  },
};
// const fancyOptions = {
// 	infobar: true,
// 	thumbs: {
// 		autoStart: true,
// 		axis: "y",
// 	},
// 	buttons: ["share", "close"],
// 	caption: "",
// };

const NavButton = (props) => {
  //   const { text, icon, target, exact, appId, button } = props;
  const { text, label, icon, target, exact, onClick } = props;
  const {
    appInfo: { trainLearnConfig, featureFlags },
  } = useSettings();
  let iconWidth = 'far';
  featureFlags.map((feature) => {
    if (feature.name === 'solid_icons' && feature.is_enabled) {
      iconWidth = 'fas';
    }
    if (feature.name === 'light_icons' && feature.is_enabled) {
      iconWidth = 'fal';
    }
  });

  return (
    <NavLink
      onClick={(e) => {
        onClick?.(e);
        if (!e.defaultPrevented) resetScrollPosition();
      }}
      activeClassName="is-active"
      exact={exact}
      to={target}
      className="link"
    >
      <li className={`button ${text.replace('.', ' ')}`}>
        <div className="button__overlay" />
        <div className="button__text">
          {i18n.translate(`${text === 'train' ? (trainLearnConfig ?? 'train') : text}`)}
        </div>
        {icon && (
          <FontAwesomeIcon
            className="button__icon"
            icon={icon.replace('far', iconWidth).replace('fa-', '').split(' ')}
          />
        )}
      </li>
    </NavLink>
  );
};

export default class ButtonSet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: -1,
      trainLearnConfig: 'train',
    };
  }

  UNSAFE_componentWillMount() {
    DataHandler.matchAppId().then((appId) => {
      this.setState({ appId });
    });
    StorageHandler.load(storageKeys.appInfo).then((info) => {
      if (info && info.trainLearnConfig) {
        this.setState({ trainLearnConfig: info.trainLearnConfig });
      }
    });
  }

  render() {
    const { buttons, orientation, variant, showRewards, rewardsLocked, onRewardsClick } = this.props;
    const resolvedButtons =
      variant === 'smartAssistHome'
        ? {
            ...SMART_ASSIST_HOME_BUTTONS,
            ...(showRewards
              ? {
                  rewards: {
                    text: 'nav.rewards',
                    icon: rewardsLocked ? 'fas fa-lock' : 'fas fa-treasure-chest',
                    target: '/main/rewards',
                    onClick: onRewardsClick,
                  },
                }
              : {}),
          }
        : buttons;
    const buttonElements = Object.values(resolvedButtons).map((button) => (
      <NavButton
        key={button.text}
        appId={this.state.appId}
        {...button}
        trainLearnConfig={this.state.trainLearnConfig}
      />
    ));

    return (
      <ul data-testid="button-set" className={orientation}>
        {buttonElements}
      </ul>
    );
  }
}

NavButton.propTypes = {
  text: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string,
  target: PropTypes.string,
  exact: PropTypes.bool,
  appId: PropTypes.string,
  button: PropTypes.string,
  onClick: PropTypes.func,
};

NavButton.defaultProps = {
  appId: -1,
  text: '',
  label: null,
  icon: null,
  target: '/',
  exact: true,
  button: '',
  onClick: null,
};

ButtonSet.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape()),
  orientation: PropTypes.string,
  variant: PropTypes.string,
  showRewards: PropTypes.bool,
  rewardsLocked: PropTypes.bool,
  onRewardsClick: PropTypes.func,
};

ButtonSet.defaultProps = {
  buttons: {},
  orientation: 'left',
  variant: null,
  showRewards: false,
  rewardsLocked: false,
  onRewardsClick: null,
};
